export default __webpack_public_path__ + "static/media/chinese.42e97621.ico";